export const BRAND = {
  name: "The Kukkad Co.",
  domain: "www.thekukkadco.com",
  phone: "9988007567",
  phoneDisplay: "+91 99880 07567",
  whatsapp: "https://wa.me/919988007567",
  location: "Sector 62, Noida, Uttar Pradesh",
  parent: "VGB Foods LLP",
  zomato: "https://www.zomato.com",
  swiggy: "https://www.swiggy.com",
  instagram: "https://www.instagram.com",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_5ea8a970-b83e-4889-9907-60a4d97990fa/artifacts/t9pqmi6n_the%20kukkad%20co.-02.webp",
  mascot: "https://customer-assets-agu9un31.emergentagent.net/job_chicken-kitchen-ui/artifacts/wmbuzh3o_image.png",
  apron: "https://customer-assets-cm19k8pv.emergentagent.net/job_5ea8a970-b83e-4889-9907-60a4d97990fa/artifacts/a3gqrh5z_the%20kukkad%20co.-03.webp",
  packaging: "https://customer-assets-cm19k8pv.emergentagent.net/job_5ea8a970-b83e-4889-9907-60a4d97990fa/artifacts/dusyorpj_the%20kukkad%20co.-04.webp",
  chefHat: "https://customer-assets-cm19k8pv.emergentagent.net/job_5ea8a970-b83e-4889-9907-60a4d97990fa/artifacts/lnctyaad_the%20kukkad%20co.-05.webp",
};

export const IMAGES = {
  heroKebab: "https://images.pexels.com/photos/36194798/pexels-photo-36194798.jpeg",
  grillMoody: "https://images.pexels.com/photos/36879455/pexels-photo-36879455.jpeg",
  dal: "https://images.pexels.com/photos/19834445/pexels-photo-19834445.jpeg",
  spread: "https://images.pexels.com/photos/20446397/pexels-photo-20446397.jpeg",
  friends: "https://images.pexels.com/photos/6210505/pexels-photo-6210505.jpeg",
};
